import { useMutation, UseMutationOptions } from 'react-query';
import { AxiosError } from 'axios';

import { UserPhoto } from 'types/interfaces/user/UserPhoto';

import { UploadPhotoPayload, UserProfileApi } from 'api/UserProfileApi';

export const useUploadPhotoMutation = (
  options?: UseMutationOptions<
    UserPhoto,
    AxiosError,
    UploadPhotoPayload,
    unknown
  >
) => {
  return useMutation(UserProfileApi.uploadPhoto, options);
};
